import { generateAccessName, AccessKey } from "../../../../../access";

/**
 * Base keys of the access sections on this page.
 */
const ACCESS_SECTION: AccessKey[] = [
	AccessKey.REPORTS,
	AccessKey.REPORTS_DETAILS,
];

/**
 * Enum representing special keys for each tab on this page.
 */
enum TabKeys {
	EXECUTOR_ORDERS_REPORT = "executorOrdersReport",
}

const generateAccessSection = (key: AccessKey): AccessKey[] => [
	...ACCESS_SECTION,
	key,
];

const ARR_ACCESS_PART_KEY: Record<TabKeys, AccessKey[]> = {
	[TabKeys.EXECUTOR_ORDERS_REPORT]: generateAccessSection(
		AccessKey.EXECUTOR_ORDERS_REPORT,
	),
};

type TabAccessNamesType = {
	[key in TabKeys]: string;
};

const TabAccessNames: TabAccessNamesType = Object.fromEntries(
	Object.entries(ARR_ACCESS_PART_KEY).map(([key, section]) => [
		key,
		generateAccessName(...section),
	]),
) as TabAccessNamesType;

/**
 * Main path for the reports page.
 */
const mainPath = `mainPage.reports.details`;

export { TabKeys, TabAccessNames, ARR_ACCESS_PART_KEY, mainPath };
